import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import { Observable, catchError, distinctUntilChanged, exhaustMap, map, of, switchMap, timer } from 'rxjs';
import { CurrentNotificationBanner } from 'src/app/shared/models/notification-banner.model';
import { NotificationBannerService } from 'src/app/shared/services/notification-banner.service';
import { Dealer } from 'src/app/shared/dealer/models/dealer';
import { DealerState } from 'src/app/shared/state/DealerState';
import { environment } from 'src/environments/environment';
import { LocationService } from '../../shared/services/location.service';

@Component({
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss'],
  standalone: false
})
export class HomeComponent implements OnInit {
  dealer: Dealer;
  public store = inject(Store);
  public locationService = inject(LocationService);
  private readonly banners = inject(NotificationBannerService);
  private readonly destroyRef = inject(DestroyRef);
  public banner: CurrentNotificationBanner | null = null;

  constructor() {
    this.dealer = this.store.selectSnapshot(DealerState.currentDealer);
    this.locationService.fetchPlants(this.dealer.id);
    this.locationService.fetchSites(this.dealer.id);
  }

  ngOnInit() {
    this.dealer = this.store.selectSnapshot(DealerState.currentDealer);
    this.store
      .select(DealerState.state)
      .pipe(
        map((state) =>
          DealerState.bannersEnabled(state) && state.currentDealer?.id && state.loggedInUser
            ? `${state.currentDealer.id}|${state.loggedInUser}`
            : ''
        ),
        distinctUntilChanged(),
        switchMap((context) => {
          this.banner = null;
          return context ? timer(0, environment.bannerPollIntervalMs).pipe(exhaustMap(() => this.loadBanner())) : of(null);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((banner) => (this.banner = banner));
  }

  private loadBanner(): Observable<CurrentNotificationBanner | null> {
    return this.banners.getCurrentBanner().pipe(
      catchError((error: unknown) => {
        console.error('Failed to load the current banner:', error);
        return of(null);
      })
    );
  }
}
